export default __webpack_public_path__ + "locales/ar-SA/OAuth.json?hash=1ff226d3fed2fc8ec134341ee2f2a848";